// 标记组件属性回退到PROPS访问的标记
// 由于mobx::observable() 无法处理React.Element格式
// 此处需要明确的标记限定:
//  假如: props.value 值是一个 JSSlot的实例,
//  如果忽略处理, 那么在 `$$vm.value` 的值就是undefined
//  $$vm.$pickit() 过程将会强制使用 `undefined` 来渲染组件
//  此过程并不符合预期
//  为了针对上述情况:
//    将此类型值做统一标记 `FALLBACK_AT_PROPS`
//    然后在`$pickit`过程中做回溯, 即可完整规避此问题的产生
export const FALLBACK_AT_PROPS = Symbol.for('FALLBACK_AT_PROPS');

// 空函数, 为各个函数式参数的默认值
export const NOOP = (o: any) => o;
